<script setup>
import BaseExchange from '@/components/BaseExchange.vue';
import BaseProduct from '@/components/BaseProduct.vue';
import { inject, ref } from 'vue'

const view = inject("view", "mobile")

const data = [
  {
    title: "Программа «Свои»",
    text: "Покупайте с кешбэком до 10% у 1000 партнеров «Свои»",
    image: {
      src: "/assets/images/svoi.png",
      alt: "Свои"
    },
    link: "https://svoi.albank.ru/",
    button: { type: 'arrow' },
    style: {
      flex: '1 300px',
      justifyContent: 'space-between'
    }
  },
  {
    title: "Умная очередь",
    text: "Экономьте время, выбирая наилучшее время для посещения банка",
    image: {
      src: "/assets/images/smart-queue.png",
      alt: "Очередь"
    },
    link: "https://albank.ru/ru/smart.php",
    style: {
      flex: '1 300px',
      cursor: 'pointer',
    }
  },
  {
    title: "Овердрафт жителя Якутии",
    text: "Дополнительный источник средств, который выручит вас в непредвиденных ситуациях",
    image: {
      src: "/assets/images/overdraft.png",
      alt: "Овердрафт"
    },
    link: 'https://albank.ru/ru/credits/yakutia-overdraft/',
    button: { 
      type: 'primary',
      text: 'Подробнее' 
    },
    style: {
      flex: '1 100%',
      height: '440px',
      background: 'var(--color-blue-100)'
    },
    mode: 'large'
  },
  {
    title: "Офисы и банкоматы",
    text: "Адреса и режим работы",
    image: {
      src: "/assets/images/map.png",
      alt: "Карта"
    },
    link: "https://albank.ru/ru/offices/",
    button: { 
      type: 'dark',
      text: "Посмотреть на карте"
    },
    style: {
      flex: '1 410px',
      height: '390px',
      justifyContent: 'space-between',
      background: 'var(--color-blue-50)'
    }
  },
]

const mobileData = [
  {
    title: "Программа лояльности «Свои»",
    text: "Получайте настоящие деньги за покупки с картой АЭБ по программе лояльности «Свои»",
    image: {
      src: "/assets/images/svoi-mobile.png",
      alt: "Свои"
    },
    link: "https://svoi.albank.ru/",
    button: { type: 'arrow' },
    style: {
      justifyContent: 'space-between'
    }
  },
  {
    title: "Кредит на любые цели",
    text: "Реализуйте свои мечты с нашим гибким кредитом на любые цели",
    image: {
      src: "/assets/images/credit-mobile.png",
      alt: "Очередь"
    },
    link: "https://albank.ru/ru/credits/simple-credit/",
    button: { type: 'arrow' },
    style: {
      justifyContent: 'space-between'
    }
  },
  {
    title: "Офисы и банкоматы",
    text: "Найдите ближайшие офисы и банкоматы для удобных финансовых операций",
    image: {
      src: "/assets/images/offices.png",
      alt: "Карта"
    },
    link: "https://albank.ru/ru/offices/",
    button: { type: 'arrow' },
    style: {
      justifyContent: 'space-between',
    }
  },
]



</script>

<template>
  <div class="screen screen-container products">
    <h2>Сервисы АЭБ</h2>

    <div class="products__content">
      <template 
        v-for="product in (view == 'mobile'? mobileData: data)"
        :key="product"
      >
        <a 
          v-if="product.link && !product.button"
          target="_blank"
          :href="product.link" 
        >
          <BaseProduct v-bind="product"/>  
        </a>
        <BaseProduct v-else v-bind="product"/>

      </template>
      <BaseExchange />
    </div>
  </div>
</template>
  
  
<style lang="scss">

.products {
  &__content {
    gap: 30px;
    width: 100%;
    display: flex;
    margin-top: 60px;
    flex-wrap: wrap;
  } 
}

</style>